import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type BloodDropIconProps = Partial<SVGIconProps>;

const BloodDropIcon: FC<BloodDropIconProps> = (props) => (
  <SVGIcon viewBox="0 0 21 20" {...props}>
    <path
      d="M10.512 14.583a.69.69 0 0 0-.571.735c.014.172.093.332.219.449s.293.182.466.182h.001a.74.74 0 0 0 .11-.009h0 .001a4.56 4.56 0 0 0 3.678-3.636h.005l.009-.052a.69.69 0 0 0-.117-.513c-.106-.149-.266-.25-.446-.28a.69.69 0 0 0-.513.117c-.149.106-.249.266-.28.446h0c-.215 1.271-1.293 2.348-2.561 2.562zm0 0l.01.062m-.01-.062l.01.062m0 0c-.155.026-.294.109-.39.233s-.142.279-.13.435.084.302.2.408.266.165.423.165l2.509-3.855c-.22 1.297-1.318 2.395-2.612 2.613zm3.025-10.612h0c2.141 2.459 3.266 5.045 3.266 7.478 0 1.807-.718 3.54-1.995 4.817s-3.01 1.995-4.817 1.995a6.81 6.81 0 0 1-4.817-1.995c-1.278-1.278-1.995-3.01-1.995-4.817 0-2.434 1.125-5.02 3.266-7.478h0c.96-1.11 2.04-2.111 3.221-2.982.094-.066.207-.101.322-.101a.56.56 0 0 1 .322.101c1.183.871 2.266 1.872 3.227 2.982z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth=".125"
    />
  </SVGIcon>
);

export default BloodDropIcon;
